import { useEffect } from 'react'
import { Container, Grid, TextField } from '@mui/material'
import Drawer from 'components/drawer/detail'
import Loading from 'components/loading/loading'
import type { DetailStateProps } from 'modules/types'
import { useGetConfigItemDetailQuery } from 'store/configItem'
import { useGetVoucherBirthdayDropdownMutation } from 'store/tokenRequest'
import DetailStyle from './style'

const Detail = ({ open, id, onClose }: DetailStateProps & { id: number }) => {
  if (!open) return <Drawer open={open} onClose={onClose} />

  const { data, isLoading, isFetching } = useGetConfigItemDetailQuery(id)
  const [getVoucherBirthdayDropdown, voucherBirthdayDropdown] = useGetVoucherBirthdayDropdownMutation()

  const name = (data && data.name) || '-'
  const description = (data && data.description) || '-'
  const category = (data && data.configGroupName) || '-'

  // Check if this is a birthday voucher config
  const isBirthdayVoucherConfig = data?.name === 'BIRTHDAY_VOUCHER'

  // Get voucher name if this is birthday voucher config
  const getVoucherValue = () => {
    if (isBirthdayVoucherConfig && data?.value) {
      if (voucherBirthdayDropdown.isLoading) {
        return 'Loading voucher...'
      }
      if (voucherBirthdayDropdown.data) {
        const voucher = voucherBirthdayDropdown.data.find(item => item.id === +data.value)
        return voucher ? voucher.name : data.value
      }
      return data.value
    }
    return (data && data.value) || '-'
  }

  const value = getVoucherValue()

  // Fetch voucher dropdown data if this is a birthday voucher config
  useEffect(() => {
    if (isBirthdayVoucherConfig && !voucherBirthdayDropdown.data) {
      getVoucherBirthdayDropdown()
    }
  }, [isBirthdayVoucherConfig, voucherBirthdayDropdown.data, getVoucherBirthdayDropdown])

  const gridDataLabel = ['Config Code', 'Config Name', 'Category', 'Value']
  const gridDataValue = [name, description, category, value]

  return (
    <Drawer open={open} title='Config Detail' onClose={onClose}>
      <Container {...DetailStyle.Container}>
        {(isLoading || isFetching) && !data && <Loading />}
        {data && (
          <Grid container spacing={2}>
            {gridDataValue.map((item, index) => (
              <Grid key={index} item xs={12}>
                <TextField
                  variant='outlined'
                  label={gridDataLabel[index]}
                  value={item}
                  inputProps={{ readOnly: true }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Drawer>
  )
}

export default Detail
